import { CookieStorageService } from '@aionzdev/design-system';
import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';

/**
 * Persiste a empresa (tenant) escolhida pelo usuário em cookie
 * (`selected_company_id`). Cookie — não localStorage — porque o app é SSR: o
 * servidor precisa do valor para renderizar a primeira página no tenant certo.
 * Segue o padrão de `CookieStorageService` do `@aionzdev/design-system`.
 */
@Injectable({ providedIn: 'root' })
export class CompanySelectionCookieService extends CookieStorageService {
  constructor() {
    super(
      'selected_company_id',
      30, // dias
      inject(DOCUMENT),
      inject(PLATFORM_ID),
      inject(Request, { optional: true }) as Request
    );
  }

  /** Id da empresa escolhida, ou null se ausente/ inválido. */
  getId(): number | null {
    const raw = this.get();
    const n = raw ? Number(raw) : NaN;
    return Number.isInteger(n) && n > 0 ? n : null;
  }

  setId(id: number): void {
    this.set(String(id));
  }
}
